import styled from 'styled-components';
import {IoIosFunnel} from 'react-icons/io';

export const RatingsContainer = styled.div`
  display: grid;
  grid-template-columns: auto auto;
  gap: 1rem;
  margin: 0 auto 2rem auto;

  @media(max-width: 992px) {
    grid-template-columns: auto;
  }

  @media(min-width: 1600px) {
    grid-template-columns: auto auto auto;
  }

  max-width: 2160px;
`;

export const RatingCard = styled.div`
  display: flex;
  flex-direction: column;
  padding: 2rem;
  box-shadow: 2px 2px 10px #E4E4E4;
  background-color: #FFF;
`;

export const RatingHeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const RatingTime = styled.p`
  font-size: 0.9rem;
  color: #707070;
`;

export const RatingNumber = styled.p`
  font-size: 1rem;
  font-weight: 500;
`;

export const RatingUserName = styled.p`
  margin: 0;
  font-size: 1.1rem;
  font-weight: 600;
  text-align: left;
`;

export const RatingUserId = styled.p`
  margin: 0;
  color: #707070;
  font-size: 0.9rem;
  text-align: left;
`;

export const RatingUserInfoContainer = styled.div`
  
`;

export const RatingUserReviemContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1.5rem;
`;

export const RatingFeedback = styled.p`

`;

export const LoadMoreButtonContainer = styled.div`
  display: flex;
  justify-content: center;
`;


export const FullContainer = styled.div`
  height: 100vh;
  width: 100%;
  background-color: rgb(248, 248, 248);
`;

export const ContentContainer = styled.div`
  width: 100%;
  padding: 0.9rem 2rem 2rem 2rem;
  background-color: inherit;
`;

export const Title = styled.h2`

`;

export const Text = styled.p`
  color: #CCC;
  margin: 0.25rem;
`;

export const Label = styled.p`
  margin: 0 0 0.5rem;
`;

export const RowContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  flex-shrink: 1;
`;

export const FilterIcon = styled(IoIosFunnel)`
  margin-right: 0.5rem;
`;

export const FilterButton = styled.button`
  border: 0;
  margin: 0;
  padding: 0.8rem 1.6rem;
  background-color: #FF7417;
  color: #FFF;
  font-weight: 600;
  border-radius: 0.5rem;

  &:hover {
    filter: brightness(90%);
  }

  &:active {
    transform: scale(0.95);
  }

`;

export const ActionButtonsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-bottom: 1rem;
`;